import { render, staticRenderFns } from "./PostPreviewBtn.vue?vue&type=template&id=254527a9&"
import script from "./PostPreviewBtn.vue?vue&type=script&lang=js&"
export * from "./PostPreviewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports